<template>
  <router-view></router-view>

</template>

<script>
import { mapActions } from 'vuex'


export default {
  name: 'App',
  methods: {  
     ...mapActions(['getToken']) 
  },
  created(){
    this.getToken()
  }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
</style>
